import { WifiOff, RefreshCw } from 'lucide-react'
import { useOfflineStore } from '@/store/offlineStore'
import { cn } from '@/utils/cn'

const OfflineBanner = () => {
  const { isOnline, isSyncing, pendingChanges } = useOfflineStore()

  if (isOnline && pendingChanges === 0) return null

  return (
    <div
      className={cn(
        'px-4 py-2 flex items-center justify-between text-sm',
        !isOnline ? 'bg-red-500 text-white' : 'bg-yellow-500 text-white'
      )}
    >
      <div className="flex items-center gap-2">
        {!isOnline ? (
          <>
            <WifiOff size={16} />
            <span>You are offline</span>
          </>
        ) : (
          <>
            {isSyncing ? (
              <RefreshCw size={16} className="animate-spin" />
            ) : null}
            <span>{pendingChanges} changes pending sync</span>
          </>
        )}
      </div>
      
      {isOnline && pendingChanges > 0 && !isSyncing && (
        <button
          onClick={() => {/* Trigger sync */}}
          className="text-xs underline hover:no-underline"
        >
          Sync Now
        </button>
      )}
    </div>
  )
}

export default OfflineBanner
